import { Component, Input, inject } from '@angular/core';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { LoaderService } from './loader.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-loader-spinner',
    templateUrl: './loader-spinner.component.html',
    styleUrls: ['./loader-spinner.component.css'],
    standalone: false
})
export class LoaderSpinnerComponent{
  private loaderService = inject(LoaderService);

  @Input() title;
  @Input() error = false;
  @Input() loading: boolean;

  constructor() {
    this.loaderService.isLoading.subscribe(v => {
      this.loading = v;
    });
  }

}

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatIconModule],
  declarations: [LoaderSpinnerComponent],
  exports: [LoaderSpinnerComponent],
})
export class LoaderSpinnerModule {}
